import { SidebarHide, SidebarShow } from '~/ui'
import { cn } from '~/utils/classnames'

import { useNavbarContext } from './navbar-context'

type NavbarTriggerProps = Omit<
  React.ComponentPropsWithoutRef<'button'>,
  'children'
> & {
  variant?: 'open' | 'close'
}

export const NavbarTrigger = ({
  onClick,
  onMouseEnter,
  onMouseLeave,
  variant = 'open',
  className,
  ...props
}: NavbarTriggerProps) => {
  const { setIsOpen } = useNavbarContext()

  return (
    <button
      onClick={(e) => {
        onClick?.(e)
        if (e.defaultPrevented) return

        setIsOpen((v) => !v)
      }}
      className={cn('relative cursor-pointer', className)}
      {...props}
    >
      <SidebarShow
        className={cn(
          'size-6 transition-opacity',
          variant !== 'open' && 'pointer-events-none opacity-0'
        )}
      />
      <SidebarHide
        className={cn(
          'absolute inset-0 size-6 transition-opacity',
          variant !== 'close' && 'pointer-events-none opacity-0'
        )}
      />
    </button>
  )
}
